module.exports = __webpack_public_path__ + "img/card2.96c6cec0.png";